import { useIdleTimer as useInactivity } from 'react-idle-timer'
import config from 'app/config'
import { useAuth } from 'hooks'

export const useIdleTimer = (delay = config.IDLE_TIMER) => {
    const { logout } = useAuth()

    const timerObj = useInactivity({
        timeout: 1000 * 60 * delay,
        onIdle: () => logout(),
        debounce: 500,
        crossTab: true,
    })

    return timerObj
}
